// @ts-nocheck
import AlgoliaSortingSelector from '@components/algolia/AlgoliaSortingSelector'
import CustomRefinementList from '@components/algolia/CustomRefinementList'
import { getFilterAttributeTitle } from '@lib/algolia'
import { slugify } from '@lib/helpers/general'
import cn from 'clsx'
import { FC, useEffect, useState, useCallback } from 'react'
import { connectDynamicWidgets } from 'react-instantsearch-dom'
import filtersToHide from '@config/filters_hidden_in_collections.json'
interface props {
  attributesToRender: string[]
  collectionHandle: string
  indexName: string
}

let noOptionsAttributes: { [key: string]: boolean } = {}

const DynamicAlgoliaFilters: FC<props> = ({
  indexName,
  collectionHandle,
  attributesToRender,
}) => {
  const [currentFilter, setCurrentFilter] = useState('')
  const [filteredAttributesToRender, setFilteredAttributesToRender] = useState<
    string[]
  >([])

  const defaultIndex = `${indexName}_published_at_desc`;

  useEffect(() => {
    const defaultFilter = filteredAttributesToRender[0]
    setCurrentFilter(getFilterAttributeTitle(defaultFilter))
  }, [filteredAttributesToRender])
  useEffect(() => {
    setFilteredAttributesToRender(
      attributesToRender.filter((attribute) => {
        if (
          collectionHandle &&
          filtersToHide[attribute]?.includes(collectionHandle)
        ) {
          return false
        }
        return true
      })
    )
  }, [collectionHandle]) // Deliberately not add attributesToRender as dependency. It caused filters selection to reset.

  const hasOptions = useCallback((attr, has) => {
    noOptionsAttributes[attr] = !has
  }, [])

  return (
    <div className="flex flex-col">
      {/* mobile view */}
      <div className="flex flex-col">
        <div className="flex-1 flex-col overflow-y-scroll lg:hidden">
          {filteredAttributesToRender.map(
            (attribute: string, index: number) => {
              const title = getFilterAttributeTitle(attribute)
              const key = slugify(`mobile` + attribute + index)
              return (
                <div
                  className={cn('mb-10', {
                    hidden: noOptionsAttributes[attribute],
                  })}
                  key={key}
                >
                  <span className="text-label font-normal uppercase hover:border-ui-dark-grey">
                    {title}
                  </span>
                  <div className="lg:hidden block mt-4">
                    <div className="capitalize mr-2 block">
                      <CustomRefinementList
                        hasOptions={hasOptions}
                        attribute={attribute}
                        limit={50}
                      />
                    </div>
                  </div>
                </div>
              )
            }
          )}
          <div className="mb-10">
            <span className="text-label font-normal uppercase hover:border-ui-dark-grey">
              Sort By
            </span>
            <div className="lg:hidden block mt-4">
              <div className="capitalize mr-2 block">
                <AlgoliaSortingSelector
                  indexName={indexName}
                  defaultIndex={defaultIndex}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Mobile view */}

      {/* desktop view */}
      <div className="hidden lg:flex items-center justify-center flex-col">
        <div className="flex gap-10 items-center flex-wrap justify-center pt-12 pb-10">
          {filteredAttributesToRender.map((attribute: any, index: any) => {
            const key = slugify(`desktop` + attribute + index)
            const title = getFilterAttributeTitle(attribute)
            const handleClick = () => {
              setCurrentFilter(title)
            }

            return (
              <div
                key={key}
                onClick={handleClick}
                className={cn(
                  'text-label font-normal uppercase px-2 rounded-sm cursor-pointer',
                  {
                    'hover:opacity-75': currentFilter !== title,
                    'bg-brand-chrome text-white': currentFilter === title,
                    hidden: noOptionsAttributes[attribute],
                  }
                )}
              >
                {title}
              </div>
            )
          })}
          <div
            className={cn(
              'text-label font-normal uppercase px-2 rounded-sm cursor-pointer  hover:opacity-75',
              {
                ' bg-brand-chrome text-white': currentFilter === 'sortBy',
              }
            )}
            onClick={() => {
              setCurrentFilter('sortBy')
            }}
          >
            SORT BY
          </div>
        </div>
        <div className="flex justify-start lg:justify-center">
          {filteredAttributesToRender.map((attribute: any, index: any) => {
            const title = getFilterAttributeTitle(attribute)
            const key = slugify(`refinements` + attribute + index)
            return (
              <div className="lg:block" key={key}>
                <div
                  className={cn('capitalize', {
                    hidden: currentFilter !== title,
                  })}
                >
                  <CustomRefinementList
                    hasOptions={hasOptions}
                    attribute={attribute}
                    //TODO: This limit needs to be confirmed
                    limit={50}
                  />
                </div>
              </div>
            )
          })}
          <div className="lg:block">
            <div
              className={cn({
                hidden: currentFilter !== 'sortBy',
              })}
            >
              <AlgoliaSortingSelector
                indexName={indexName}
                defaultIndex={defaultIndex}
              />
            </div>
          </div>
        </div>
      </div>
      {/*  End desktop  view  */}
      <style jsx global>
        {`
          .ais-ClearRefinements-button {
            text-decoration: underline;
          }
          .ais-RefinementList-item--selected {
            border: 1px solid #464544 !important;
            border-radius: 4px;import { useCallback } from 'react';

          }
          .ais-RefinementList-item {
            border: 1px solid transparent;
            border-radius: 4px;
          }
        `}
      </style>
    </div>
  )
}

const AlgoliaFilters = connectDynamicWidgets(DynamicAlgoliaFilters)

export default AlgoliaFilters
